var _g, _path, _g2, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionicon = function SvgQuestionicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0798c4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 126.2v1c-.3-.2-.4-.5-.4-.9h.4zm2.1-7.1c0-.2.1-.4.2-.6zm1.9-5.9c0-.2.2-.2.2-.2zm-1.7 4.9c0-.1.2-.2.2-.2zM24.9 119.5c0-.1.2-.2.2-.2zm-1.9 6.3v-.2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "m46.4 150-.7-.9-4.2-4c-5.6-5.5-11.9-12.8-17.7-17.6h1.3l20.9-6.7c2 .7 3.7 2.1 5.6 3 23.4 11.7 51.7 4 66.8-16.9 12.7-17.6 13.8-41 2.5-59.6s-2.5-3.5-3.6-5.3c3.1 2.1 7.7 7.1 10.6 9.9l20.9 20.8 1.1.8V150z",
    opacity: 0.2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#0798c4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6 124.2c0 .4-.1 1.1-.6 1 0-.3.2-.6.2-.9h.4zm.5-1.7c0 .4-.1 1.1-.6 1 0-.3.2-.6.2-.9h.4zm.4-1.1c0 .3-.1.5-.4.6.1-1 .2-.4.4-.6m2.1-6.3c0 .3-.1.5-.4.6.2-1 .2-.4.4-.6m2.3-6.7c0 .3-.1.5-.4.6 0-1 .1-.4.4-.6M28.5 109.5v.4h-.4v-.4zm1-3h-.1zv.2zm-2.1 5.9c0-.1.2-.2.2-.2z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdfdfd",
    stroke: "#21366c",
    strokeMiterlimit: 10,
    strokeWidth: 3.9,
    d: "M107.9 32.8s6.9 4.6 13 14.5c11.3 18.6 10.2 42-2.5 59.6-15.1 20.9-43.4 28.6-66.8 16.9-1.9-.9-3.6-2.3-5.6-3l-22.3 6.7c-.2-.2-.6-.2-.8-.4 0-.3 6.5-22.6 6.5-22.6-1.4-3-3.3-5.6-4.7-8.8C7.9 55 44.9 13.1 87.5 22.9c11.1 2.4 20.5 9.9 20.5 9.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0798c4",
    d: "m114.1 38.3.4.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#052a5e",
    d: "M80 88.9H67.6l-.2-3.9c0-4 1-7.4 3.6-10.5 4.2-4.7 12.9-6.5 12.6-14.2-.3-10.1-15.7-10.9-17.9-1.3s0 2-.5 2.7H52.4l-.3-.3v-2.9c0-.6.5-2.3.7-3 6-21.6 47.1-19.3 45.3 6-.7 9.8-7.8 11.9-14.1 17.1s-4 5.7-3.9 10.1zm-7.3 5.9c8.6-1.2 12.6 9.9 5.5 14.3-7 4.3-15.1-3.8-10.9-10.7 1.1-1.7 3.4-3.3 5.4-3.6"
  })));
};
export default SvgQuestionicon;